<template>
  <div class="adminAccount">
    <div class="d bar">
      <p class="a_back" @click="goBack"><i class="iC i_back"></i></p>
      <div class="ssC">
        <div class="ss_inp_cnt">
          <!-- @change="searchKey" -->
          <input
            type="text"
            class="ss_inp"
            v-model="username"
            placeholder="输入用户名可快速查找"
          />
          <p class="ss_btn ss_btn1" @click="searchKey"><span>查找</span></p>
        </div>
        <!-- <p @click="add" class="ss_btn ss_btn2"><span>添加账号</span></p> -->
      </div>
    </div>
    <div class="adminAccount-search">
      <comp-address
        :province="province"
        :city="city"
        :district="district"
        :provinceCode="provinceCode"
        :cityCode="cityCode"
        :districtCode="districtCode"
        :selectArea="selectArea"
        :type="'search'"
      ></comp-address>
      <select-item
        title="请选择账号状态"
        :value="statusName"
        :list="statusList"
        :handlerSelect="selectStatus"
        name="name"
      ></select-item>
      <select-item
        title="指定身份"
        :value="roleName"
        :list="showRoleList"
        :handlerSelect="selectRole"
        name="roleName"
      ></select-item>
    </div>

    <div
      class="d d_zhsm"
      v-if="total > 0 && status == -1 && operationRoleId - 1 == currentRoleId"
    >
      <p>提示</p>
      <p>有{{ total }}个申请找回密码的账号待处理</p>
    </div>

    <div class="d d_cy">
      <ul class="u4 u4_tit">
        <li>用户名</li>
        <li>级别</li>
        <li>地区</li>
        <li>状态</li>
      </ul>

      <van-pull-refresh v-model="refreshing" @refresh="onRefresh"  class="order-list-refresh">
        <van-list
          v-model:loading1="loading1"
          :finished="finished"
          :finished-text="finishedText"
          @load="onLoad"
          @offset="100"
        >
         <div class="list-cnt">
          <van-radio-group v-model="changeUser" @change="updateChecked">
            <div v-for="item in userList" :key="item.id">
              <list-item
                :item="item"
                :radClick="radClick"
                :currentRoleId="currentRoleId"
              />
            </div>
          </van-radio-group>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="ft ft_sh">
      <div class="d f_opa">
        <label>操作：</label>
        <p @click="operation(1)">禁用</p>
        <p @click="operation(2)">启用</p>
        <p @click="operation(3)">修改密码</p>
        <!-- <p @click="operation(4)">重置密码</p> -->
        <p @click="operation(5)">修改账号</p>
      </div>
    </div>

    <t-Message
      :visible="pwdVisible"
      :handler="updatePwd"
      :handlerClose="handlerClose"
    ></t-Message>
  </div>
</template>
<script>
import { reactive, toRefs, getCurrentInstance, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { Toast } from "vant";
import {
  getApiUserList,
  setChangePwd,
  disableAccount,
  enableAccount,
  setResetPwd,
} from "@/service/user";
import CompAddress from "@/components/Address.vue";
import SelectItem from "@/components/SelectItem.vue";
import tMessage from "@/components/InputMessage.vue";
import ListItem from "@/components/ListItem";
import { tipsMsg, REG_PWD, getRoleId, getLocal } from "@/common/js";

export default {
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const { proxy } = getCurrentInstance();
    const state = reactive({
      currentRoleId: -1,
      roleId: -1,
      roleName: "",
      username: "",
      province: "不限",
      city: "不限",
      district: "不限",
      provinceCode: "100000",
      cityCode: "",
      districtCode: "",
      status: -2,
      statusName: "",
      statusList: [
        { name: "申请找回密码", status: -1 },
        { name: "正常", status: 1 },
        { name: "已禁用", status: 0 },
      ],
      userList: [],
      page: 1,
      size: 50,
      loading1: false,
      finished: false,
      finishedText: "没有更多了",
      refreshing: false,
      changeUser: "",
      changeUserRole: "",
      total: 1,
      totalPage: 1,
      roleList: [],
      showRoleList: [],
      pwdVisible: false,
      radioChange: false,
      operationRoleId: -1,
    });

    // 重置数据
    const initData = () => {
      state.userList = [];
      state.page = 1;
      state.loading1 = false;
      state.finished = false;
      state.refreshing = false;
      state.changeUser = "";
    };

    onMounted(async () => {
      const { isVerify } = route.query;
      if (isVerify == "true") {
        state.status = -1;
        state.statusName = "申请找回密码";
      }
      if (state.currentRoleId <= 0) {
        const roleId = await getRoleId();
        if (roleId) {
          state.currentRoleId = roleId;
        }
      }

      // 回显
      const {
        roleList,
        province,
        provinceCode,
        city,
        cityCode,
        district,
        districtCode,
      } = store.state.info;

      if (roleList.length > 0) {
        let newList = JSON.parse(JSON.stringify(roleList));
        newList.unshift({ roleId: -1, roleName: "不限" });
        state.roleList = newList;
        state.showRoleList = newList;
      }
      const dsjstore = getLocal("dsj_store");
      console.log('dsjstore --> ', dsjstore)
      console.log('store.state.info -->', store.state.info)
      console.log('state -->', state)
      console.log('showRoleList -->', state.showRoleList)
      if (province != null) {
        state.province = province;
        state.provinceCode = provinceCode;
      }
      if (city != null) {
        state.city = city;
        state.cityCode = cityCode;
      }
      if (district != null) {
        state.district = district;
        state.districtCode = districtCode;
      }
      onLoad()

    });
  
    const onLoad = async () => {
      if (state.loading1) {
        return;
      }
      if (!state.refreshing && state.page < state.totalPage) {
        state.page = state.page + 1;
      }

      if (state.refreshing) {
        state.userList = [];
        state.refreshing = false;
      }
      // todo
      state.loading1 = true;
      getUserList();
    };
    const onRefresh = () => {
      // 清空列表数据
      state.userList = [];
      state.refreshing = true;
      state.finished = false;
      // 重新加载数据
      // 将 loading1 设置为 true，表示处于加载状态
      state.loading1 = false;
      state.page = 1;
      onLoad();
    };
    const searchKey = async () => {
      initData();
      onRefresh();
    };
    const getUserList = async () => {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      try {
        const { page, size, username, province, city, district, status, roleId } = state;
        let p = province,
          c = city,
          d = district;
        if (province == "不限") {
          p = "";
        }
        if (city == "不限") {
          c = "";
        }
        if (district == "不限") {
          d = "";
        }
        const {
          data,
          data: { userList = [], total = 0 },
          code,
        } = await getApiUserList({
          size,
          page,
          username,
          province: p,
          city: c,
          district: d,
          status,
          roleId,
        });
        if (code === 10000) {
          if (userList.length > 0) {
            state.userList = state.userList.concat(userList);
          }
          if (data.userList.length > 0) {
            state.operationRoleId = data.userList[0].roleId;
          }
          state.total = total;
          state.totalPage = data.totalPage;
          state.loading1 = false;
          if (state.page >= data.totalPage) {
            state.finished = true;
          }
        }
        Toast.clear();
      } catch (error) {
        state.loading1 = false;
        state.finished = true;
        state.finishedText = "服务异常，请稍后重试";
        Toast.clear();
      }
    };

    const add = () => {
      const { status } = state;
      router.push({ path: "/organization/adminAccount/add", query: { status } });
    };
      const radClick = (e) => {
      state.changeUserRole = e.roleId;
    };
    const updateChecked = (e) => {
      console.log("updateChecked", e);
    };

    const selectRole = async (role) => {
      state.roleId = role.roleId;
      state.roleName = role.roleName;
      initData();
      await onRefresh();
    };

    // 选择省市区
    const selectArea = async (area) => {
      // console.log('area -->', area)
      // 重置数据
      initData();
      // if (JSON.stringify(area).indexOf("不限") != -1) {
      //   const { province = "", city = "", district = "" } = area;
      //   if (province != "" && province == "不限") {
      //     state.province = "不限";
      //     state.city = "不限";
      //     state.district = "不限";
      //   }
      //   if (city != "" && city == "不限") {
      //     state.city = "不限";
      //     state.district = "不限";
      //   }
      //   if (district != "" && district == "不限") {
      //     state.district = "不限";
      //   }
      // } else {
        // 合并
        Object.assign(state, area);
        console.log('state -->', state)
      // }
      await onRefresh();
    };
    const selectStatus = async (e) => {
      if (e) {
        // 重置数据
        initData();
        const { name, status } = e;
        state.status = status;
        state.statusName = name;
        if (status == -1) {
          const rlist = state.roleList.filter((res) => {
            if (res.roleId == state.currentRoleId + 1) {
              return res;
            }
          });
          state.showRoleList = rlist;
        } else {
          state.showRoleList = state.roleList;
        }

        await onRefresh();
      }
    };

    const goBack = () => {
      router.push({ path: "/organization/management" });
    };
    // 修改密码
    const updatePwd = async (value) => {
      if (value == "") {
        tipsMsg("提示", "请输入需要修改的密码");
        return false;
      } else if (!REG_PWD.test(value)) {
        tipsMsg("提示", "密码必须由8~12位字母和数字的组合，区分大小写");
        return false;
      }
      const { changeUser } = state;
      const { code } = await setChangePwd({
        username: changeUser,
        pwd: value,
      });
      if (code === 10000) {
        tipsMsg("提示", "修改成功");
        state.changeUser = "";
        initData();
        state.refreshing = true;
        onLoad();
      }
      handlerClose();
    };
    // 禁用账号
    const disable = async (username) => {
      proxy.$tipsMessage(
        true,
        1,
        "提示",
        `账号禁用后将不能登录，确定要禁用此账号吗？`,
        async () => {
          const { code } = await disableAccount({ username });
          if (code === 10000) {
            changeUser(username, 0, "已禁用");
          }
          proxy.$tipsMessage(false);
        },
        true
      );
    };
    // 启用账号
    const enable = async (username) => {
      proxy.$tipsMessage(
        true,
        1,
        "提示",
        `账号启用后将正常使用，确定要启用此账号吗？`,
        async () => {
          const { code } = await enableAccount({ username });
          if (code === 10000) {
            changeUser(username, 1, "正常");
            state.changeUser = "";
          }
          proxy.$tipsMessage(false);
        },
        true
      );
    };
    const changeUser = (username, status, statusStr) => {
      const { userList } = state;
      userList.filter((user) => {
        if (user.userName == username) {
          user.status = status;
          user.statusStr = statusStr;
          state.changeUser = "";
        }
      });
    };

    // 重置密码
    const resetPwd = () => {
      const { changeUser } = state;
      proxy.$tipsMessage(
        true,
        1,
        "提示",
        `您确定重置${changeUser}账号吗？<br/>密码重置后将恢复为初始密码`,
        async () => {
          const { code } = await setResetPwd({ username: changeUser });
          console.log("code", code);
          if (code === 10000) {
            console.log("密码重置成功");
            tipsMsg("提示", "密码重置成功");
            state.changeUser = "";
          }
          proxy.$tipsMessage(false);
        },
        true
      );
    };
    const operation = async (type) => {
      const { changeUser, changeUserRole } = state;
      if (changeUser == "") {
        tipsMsg("提示", "请选择操作的用户");
        return false;
      }
      if (changeUserRole == 1) {
        tipsMsg("提示", "您没有权限修改此账号");
        return false;
      }
      switch (type) {
        case 1:
          // 禁用
          disable(changeUser);
          break;
        case 2:
          // 启用
          enable(changeUser);
          break;
        case 3:
          // 修改密码
          state.pwdVisible = true;
          break;
        case 4:
          // 重置密码
          resetPwd();
          break;
        case 5:
          // 修改账号
          updateAccount();
          break;
      }
    };
    const updateAccount = () => {
      const { changeUser, status, statusName } = state;
    
      router.push({
        path: "/organization/adminAccount/edit",
        query: { username: changeUser, status, statusName },
      });
    };

    const handlerClose = () => {
      state.pwdVisible = false;
    };
    return {
      ...toRefs(state),
      goBack,
      add,
      selectArea,
      selectStatus,
      onRefresh,
      onLoad,
      operation,
      updateChecked,
      enable,
      searchKey,
      selectRole,
      updatePwd,
      handlerClose,
      radClick,
    };
  },
  components: {
    CompAddress,
    SelectItem,
    ListItem,
    tMessage,
  },
};
</script>
<style lang="less" scoped>
.adminAccount {
  margin-bottom: 50px;
  &-list {
    margin-bottom: 50px;
  }
  &-footer {
    position: fixed;
    bottom: 0;
    height: 50px;
    width: 100%;
    flex: 1;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #f90;
  }
}
.f_opa p {
  display: inline-block;
  color: #0e97f9;
  margin: 0 0.107rem;
}
.ss_inp {
  width: 4.8rem;
}
.ss_inp_cnt {
  float: left;
  // width: 6.8rem;
  width: 98%;
  overflow: hidden;
}
</style>
